import { render, staticRenderFns } from "./insurancePolicy.vue?vue&type=template&id=f2622198&scoped=true"
import script from "./insurancePolicy.vue?vue&type=script&lang=js"
export * from "./insurancePolicy.vue?vue&type=script&lang=js"
import style0 from "./insurancePolicy.vue?vue&type=style&index=0&id=f2622198&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2622198",
  null
  
)

export default component.exports